import React from 'react'
import withIcon from '@/components/withIcon'

const IconActivities = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 5.5C15.6046 5.5 16.5 4.60457 16.5 3.5C16.5 2.39543 15.6046 1.5 14.5 1.5C13.3954 1.5 12.5 2.39543 12.5 3.5C12.5 4.60457 13.3954 5.5 14.5 5.5Z"
        stroke="#162941"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M4.5 10.5L6.2 7.94501C6.29163 7.80767 6.41584 7.69515 6.56154 7.6175C6.70724 7.53985 6.8699 7.49949 7.035 7.5H10.5L15.5 9.50001L17.224 12.947C17.307 13.1131 17.4346 13.2528 17.5925 13.3505C17.7504 13.4481 17.9323 13.4999 18.118 13.5H20.5"
        stroke="#162941"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M20.5 21C21.8807 21 23 19.8807 23 18.5C23 17.1193 21.8807 16 20.5 16C19.1193 16 18 17.1193 18 18.5C18 19.8807 19.1193 21 20.5 21Z"
        fill="#162941"
      />
      <path
        d="M10.5034 7.5L8.19145 12.9C8.00196 13.3445 7.9798 13.8426 8.12907 14.3021C8.27834 14.7617 8.58894 15.1517 9.00345 15.4L12.0204 17.211C12.1685 17.2997 12.2911 17.4253 12.3763 17.5755C12.4615 17.7257 12.5063 17.8954 12.5064 18.068V22.5"
        stroke="#162941"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M7.5 18.5L5.5 22.5"
        stroke="#162941"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15.4995 9.5L13.3125 14.094"
        stroke="#162941"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default withIcon(IconActivities)
